"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkinDiagnosis = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../contexts");
var _utils = require("../utils");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const RevieveSkinDiagnosis = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "NovageSkincareAdvisor_RevieveSkinDiagnosis" */'../components/RevieveSkinDiagnosis'))).then(module => ({
  default: module.RevieveSkinDiagnosis
})));
const SkinDiagnosis = () => {
  const {
    initialOpenDone,
    novageSkincareConfiguration
  } = (0, _contexts.useNovageSkincareAdvisor)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": getTestId(_constants.SKIN_DIAGNOSIS),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: null,
      children: initialOpenDone && (0, _utils.isValidNovageSkincareConfiguration)(novageSkincareConfiguration) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(RevieveSkinDiagnosis, {}) : null
    })
  });
};
exports.SkinDiagnosis = SkinDiagnosis;
